import { gql } from '@apollo/client/core'
import type { User } from '../types/user'

export const ME_QUERY = gql`
  query Me {
    me {
      id
      firstName
      lastName
      email
      phone
      fipsasNumber
    }
  }
`

export type MeQuery = {
  __typename: 'Query'
  me: User
}

export type MeQueryVariables = object
